import axios from 'axios';
import { action, Module, mutation, VuexModule } from 'vuex-class-component';
import { vxm } from '@/store.vuex';
import { NotificationPreferences } from '../../models/userdata/notificatonmap';

@Module({ namespacedPath: 'notificationpreference/' })
export class NotificationPreferenceStore extends VuexModule {
  private notificationPreference: NotificationPreferences = new NotificationPreferences();

  get userNotificationPreferences() {
    return this.notificationPreference;
  }

  @mutation
  public setUserNotificationPreference(notificationPreferences) {
    this.notificationPreference = notificationPreferences;
  }

  @action({ mode: 'mutate' })
  public async updateUserNotificationPreferences(notificationPreference) {
    notificationPreference.doNotTriggerEvent = false;
    const jwtToken = vxm.users.getToken;
    const token = 'Bearer ' + jwtToken;
    const payLoadUrl = '/wl-profile-svc/api/v2/notificationPreferences';
    const response = await axios.post(payLoadUrl, notificationPreference, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    // response.data.meta.success
    this.geUserNotificationPreferences();
    vxm.users.setNotifcationtypeMap(notificationPreference);
    return response;
  }

  @action({ mode: 'mutate' })
  public async geUserNotificationPreferences() {
    const response = await axios.get(
      '/wl-profile-svc/api/v2/notificationPreferences',
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    console.log('getUserNotificationPreferences in store', response.data.data);
    this.setUserNotificationPreference(response.data.data);
    return response.data.data;
  }
}
